import { ActionType } from "../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../react-core/Flux/BaseStore";
import { User } from "../../../Wrap/Models/Models/User/User";

import { UserDispatcher } from "./Variable";

export interface UserStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    UserInfo?: User;
}

export class UserStoreStatic extends BaseStore<UserStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(UserDispatcher, (actionData) =>
            this.onUserStoreResponse(actionData)
        );
    }

    public getLastResult(): UserStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): UserStoreStaticState {
        return { actionType: ActionType.Loading };
    }

    public getUserInfo(): User {
        return this.getState().UserInfo;
    }

    private onUserStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({
                    actionType: ActionType.Success,
                    isLoading: false, 
                    UserInfo: actionData.payload,
                });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}